export default import.meta.ROLLDOWN_FILE_URL_4Qc_o9wG2Gyus0$7tJm$Zg